<template>
  <div :class="['', ratioClass ? `embed-responsive ${ratioClass}`:'']">
      <iframe
        id="videoEmbed"
        :class="[ratioClass ? 'embed-item': 'wf-w-full wf-h-full']"
        :src="srcSource"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        :controls="controls"
        :autoplay="autoplay"
        responsive
        allowfullscreen
        width="620"
        height="300"
        style="display: inline; background-position: center; background-repeat: no-repeat; background-size: cover;"
      ></iframe>
    </div>
</template>

<script>
    export default {
      props:{
        source:{
          type: String,
          required: true
        },
        sourceType:{
          type: String,
          required: true
        },
        autoplay:{
          type: Boolean,
          default: false
        },
        controls:{
          type: Boolean,
          default: false
        },
        ratio:{
          // At the moment Vimeo only works with 16:9 ratio
          type: String,
          default: null
        },
        posterBackground: {
          type: String,
          default: '/img/video-placeholder.jpg'
        }
      },
      mounted() {
        document
          .getElementById('videoEmbed')
          .style
          .backgroundImage = "url('"+this.posterBackground+"')"
      },

      methods: {
        loadPoster() {
          // -> https://img.youtube.com/vi/N1Xjxkla8Es/0.jpg
        },
        youtubeSource() {
          this.source.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|videos\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)?/);
          return `https://www.youtube.com/embed/${RegExp.$6}`;
        },
        vimeoSource() {
          let embed = "https://player.vimeo.com/video/";
          if (this.source.indexOf('mp4') === -1){
            this.source.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|videos\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)?/);
            embed = embed + RegExp.$6;
          }else{
            return this.source;
          }
          return embed;
        },
      },
      computed: {
        ratioClass(){
          console.log(this.ratio, 'ratio')
          switch(this.ratio){
            case '16:9':
              return 'wf-w-1/2 wf-h-48';
            case '4:3':
              return 'wf-pb-3/4';
            case '1':
            case '1:1':
              return 'wf-pb-full';
            case '21:9':
              return 'wf-pb-9/21';
          }
          return null;
        },
        srcSource() {
          if (!this.source) return null;
          return this.sourceType === 'youtube'
            ? this.youtubeSource()
            : this.vimeoSource()
        }
      }
    }
</script>
